import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Send } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Input } from "@/components/ui/input";

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = () => api.get("/portal/messages").then(({ data }) => setMessages(data));
  useEffect(() => { load(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    setSending(true);
    try {
      await api.post("/portal/messages", { body: body.trim() });
      setBody("");
      await load();
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="portal-messages">
      <div className="mb-8">
        <p className="overline text-primary">Secure Messages</p>
        <h1 className="font-serif text-4xl text-slate-900 mt-1">Talk to your advisor</h1>
        <p className="text-slate-500 mt-2">Private, encrypted messaging with the Sagos team.</p>
      </div>

      <div className="rounded-2xl border border-border bg-white flex flex-col h-[60vh]">
        <div className="px-6 py-4 border-b border-border flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[#0b2a5b] text-white flex items-center justify-center font-serif">MS</div>
          <div>
            <p className="font-medium text-slate-800">Marcus Sagos</p>
            <p className="text-xs text-emerald-600">● Principal Advisor · usually replies in 1 business day</p>
          </div>
        </div>

        <ScrollArea className="flex-1 px-6 py-5">
          <div className="space-y-4">
            {messages.map((m) => {
              const mine = m.sender === "client";
              return (
                <div key={m.id} data-testid={`msg-${m.id}`} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[75%] rounded-2xl px-4 py-3 text-[0.95rem] leading-relaxed ${
                    mine ? "bg-primary text-primary-foreground rounded-br-sm" : "bg-[#f4f7fd] text-slate-800 rounded-bl-sm"
                  }`}>
                    {m.body}
                  </div>
                </div>
              );
            })}
            <div ref={endRef} />
          </div>
        </ScrollArea>

        <form onSubmit={send} data-testid="message-form" className="p-4 border-t border-border flex items-center gap-3">
          <Input
            data-testid="message-input"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write a message…"
            className="flex-1"
          />
          <button
            type="submit"
            data-testid="message-send"
            disabled={sending || !body.trim()}
            className="h-11 w-11 shrink-0 rounded-full bg-primary text-primary-foreground flex items-center justify-center hover:bg-[#0b2a5b] transition-colors duration-200 disabled:opacity-50"
          >
            <Send size={18} />
          </button>
        </form>
      </div>
    </div>
  );
}
